(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* =====================================================
       ZCOCOBOX — GLOBAL INITIALIZATION
       ===================================================== */

    document.documentElement.classList.add('zc-js');


    /* =====================================================
       MOBILE NAVIGATION
       ===================================================== */

    const menuButton = document.querySelector('[data-zc-menu-button]');
    const mobileMenu = document.querySelector('[data-zc-mobile-menu]');

    if (menuButton && mobileMenu) {

      menuButton.addEventListener('click', function () {

        const isOpen =
          menuButton.getAttribute('aria-expanded') === 'true';

        menuButton.setAttribute(
          'aria-expanded',
          String(!isOpen)
        );

        mobileMenu.classList.toggle('is-open', !isOpen);

        document.body.classList.toggle(
          'zc-menu-open',
          !isOpen
        );
      });


      const mobileLinks =
        mobileMenu.querySelectorAll('a');

      mobileLinks.forEach(function (link) {

        link.addEventListener('click', function () {

          menuButton.setAttribute(
            'aria-expanded',
            'false'
          );

          mobileMenu.classList.remove('is-open');

          document.body.classList.remove(
            'zc-menu-open'
          );

        });

      });


      document.addEventListener('keydown', function (event) {

        if (event.key === 'Escape') {

          menuButton.setAttribute(
            'aria-expanded',
            'false'
          );

          mobileMenu.classList.remove('is-open');

          document.body.classList.remove(
            'zc-menu-open'
          );

        }

      });

    }


    /* =====================================================
       SMOOTH INTERNAL LINKS
       ===================================================== */

    const internalLinks =
      document.querySelectorAll('a[href^="#"]');

    internalLinks.forEach(function (link) {

      link.addEventListener('click', function (event) {

        const targetId =
          link.getAttribute('href');

        if (
          !targetId ||
          targetId === '#' ||
          targetId.length < 2
        ) {
          return;
        }

        const target =
          document.querySelector(targetId);

        if (!target) {
          return;
        }

        event.preventDefault();

        const header =
          document.querySelector(
            '.zc-header, header'
          );

        const headerHeight =
          header ? header.offsetHeight : 0;

        const targetPosition =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          headerHeight -
          15;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });

      });

    });


    /* =====================================================
       REVEAL ON SCROLL
       ===================================================== */

    const revealElements =
      document.querySelectorAll(
        '.zc-reveal, [data-zc-reveal]'
      );

    if (
      revealElements.length &&
      'IntersectionObserver' in window
    ) {

      const revealObserver =
        new IntersectionObserver(
          function (entries, observer) {

            entries.forEach(function (entry) {

              if (!entry.isIntersecting) {
                return;
              }

              entry.target.classList.add(
                'is-visible'
              );

              observer.unobserve(entry.target);

            });

          },
          {
            threshold: 0.12,
            rootMargin: '0px 0px -40px 0px'
          }
        );


      revealElements.forEach(function (element) {

        element.classList.add('zc-reveal-ready');

        revealObserver.observe(element);

      });

    }


    /* =====================================================
       COCO — SMALL GLOBAL EASTER EGG
       ===================================================== */

    const cocoButtons =
      document.querySelectorAll(
        '[data-coco-message]'
      );

    cocoButtons.forEach(function (button) {

      button.addEventListener('click', function () {

        button.classList.remove('is-active');

        window.setTimeout(function () {
          button.classList.add('is-active');
        }, 20);

      });

    });


    /* =====================================================
       WAION SIGNATURE
       ===================================================== */

    const waionSignature =
      document.querySelector(
        '.zc-footer__waion'
      );

    if (waionSignature) {

      waionSignature.setAttribute(
        'aria-label',
        'Crafted by Waion'
      );

    }


    /* =====================================================
       PREVENT BODY LOCK FROM SURVIVING NAVIGATION
       ===================================================== */

    window.addEventListener('pageshow', function () {

      document.body.classList.remove(
        'zc-menu-open'
      );

    });

  });


  /* =======================================================
     GLOBAL RESIZE CLEANUP
     ======================================================= */

  window.addEventListener('resize', function () {

    if (window.innerWidth > 749) {

      const mobileMenu =
        document.querySelector(
          '[data-zc-mobile-menu]'
        );

      const menuButton =
        document.querySelector(
          '[data-zc-menu-button]'
        );

      if (mobileMenu) {
        mobileMenu.classList.remove('is-open');
      }

      if (menuButton) {
        menuButton.setAttribute(
          'aria-expanded',
          'false'
        );
      }

      document.body.classList.remove(
        'zc-menu-open'
      );

    }

  });

})();